/**
 * hls.js doesn't handle looping very well in Safari with the loop attribute.
 * This method makes it a little better.
 *
 */
export default function falseLoop() {
  const player = this;
  player.ontimeupdate = () => {
    if (player.currentTime > player.duration - 0.5) {
      player.currentTime = 0;
    }
  };
}
